import { Attribute } from 'types/attributes';

export const removeDuplicates = (chips: (Attribute | null)[]): Attribute[] => {
    return chips.filter(
        (chip): chip is Attribute =>
            !!chip &&
            chips.findIndex((c) => c?.displayName === chip.displayName) ===
                chips.indexOf(chip),
    );
};
